import { c as _c } from "react/compiler-runtime";
import { ContainerStyled } from '@/app/components/layouts/container';
import { MenuItem } from '@/app/components/layouts/top-navigation/shared/menu-item';
import { TOP_NAV_MENU_LABEL } from '@/app/constants/top-navigation';
import type { NavMenuItemType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
import { cnva } from '@/app/utils/cnva';
const DESKTOP_TITLE = 'ดูข้อมูล';
export const MenuGroupStyled = cnva('font-noto-bold text-body-1 space-y-4 text-gray-900 xl:space-y-0');
export interface MenuGroupProps {
  item: NavMenuItemType;
  hideTitle?: boolean;
  isModelBuyingTools?: boolean;
  isDesktop?: boolean;
  className?: string;
  onClose?: () => void;
}
export const MenuGroup = t0 => {
  const $ = _c(16);
  const {
    item,
    isModelBuyingTools: t1,
    isDesktop: t2,
    hideTitle: t3,
    className,
    onClose
  } = t0;
  const isModelBuyingTools = t1 === undefined ? false : t1;
  const isDesktop = t2 === undefined ? false : t2;
  const hideTitle = t3 === undefined ? false : t3;
  const isBuyingToolsOrDesktop = isModelBuyingTools || isDesktop;
  const itemTitle = item.title ?? (isDesktop && item.children ? DESKTOP_TITLE : "");
  const t4 = item.title ?? TOP_NAV_MENU_LABEL;
  let t5;
  if ($[0] !== className || $[1] !== isBuyingToolsOrDesktop) {
    t5 = MenuGroupStyled({
      className: cn({
        "xl:space-y-1": !!isBuyingToolsOrDesktop
      }, className)
    });
    $[0] = className;
    $[1] = isBuyingToolsOrDesktop;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== hideTitle || $[4] !== isBuyingToolsOrDesktop || $[5] !== itemTitle) {
    t6 = !hideTitle && !!itemTitle && <p className={cn("text-body-2-fixed font-noto text-gray-700 xl:pb-4", ContainerStyled({
      size: isBuyingToolsOrDesktop ? "none" : "sm",
      maxWidth: "none"
    }))}>{itemTitle}</p>;
    $[3] = hideTitle;
    $[4] = isBuyingToolsOrDesktop;
    $[5] = itemTitle;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isBuyingToolsOrDesktop || $[8] !== item.children || $[9] !== onClose) {
    t7 = item.children?.map((item_0, index) => <MenuItem key={`listitem${index}`} item={item_0} noContainer={isBuyingToolsOrDesktop} onClose={onClose} />);
    $[7] = isBuyingToolsOrDesktop;
    $[8] = item.children;
    $[9] = onClose;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <nav aria-label={t4} role="menubar" className={t5}>{t6}{t7}</nav>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};